export default {"src":"/_next/static/media/asharq_logo.00f9b3ef.svg","height":68,"width":148,"blurWidth":0,"blurHeight":0};